import {request} from '@/utils/axiosFun.js'

//地图下方按省份排序查询
export const provinceNumSortQuery = (query) => {
    return request('get','/yunDuanUrl/dmsm-service-cloud/mapPage/provinceNumSortQuery',query)
}

//地图数据查询
export const mapDataQuery = (query) => {
    return request('get','/yunDuanUrl/dmsm-service-cloud/mapPage/mapDataQuery',query)
}
//本年每月采集数据量统计
export const collectDataStat = (query) => {
    return request('get','/yunDuanUrl/dmsm-service-cloud/mapPage/collectDataStat',query)
}

//指纹数量与诊断算法数量
export const curveAndDiagNumStat = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/mapPage/curveAndDiagNumStat`);
}

//不同类型缺陷数量
export const defectNumStat = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/mapPage/defectNumStat`);
}

//变电站数量统计
export const subStatQuery = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/mapPage/subStatQuery`);
}